import React from 'react';

import './index.less';

import Icon from './../basic-icon';
export default () => (
    <div className="footer">
        <div className="copyright">
        {/* <p>© 2020 安徽城市管理职业学院诊断与改进工作办公室. All Rights Reserved.</p> */}
        <a href="http://beian.miit.gov.cn" target="_blank"><p>© 2021 CIQA全国高校质量保障联盟. All Rights Reserved.粤ICP备2021113373号-3</p></a>
        {/* <p>京公网安备 11010502038309号</p> */}
        </div>
    </div>
)